import './on-fly-public-path';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import { QueryClient } from '@tanstack/react-query';

import { setChatbotAskQuestionGlobal } from 'utils/chatbot-message-to-jsx/getOnClickFunc';
import { GlobalDevStyle } from 'components/GlobalStyle/GlobalDevStyle';

import App from './App';
import { config } from './config';
import { subscribeToPubSubTopicEarly } from 'subscribeToPubSubTopicEarly';

setChatbotAskQuestionGlobal();
subscribeToPubSubTopicEarly();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 0,
    },
  },
});

ReactDOM.createRoot(document.getElementById('get-support-root')).render(
  <React.StrictMode>
    <RecoilRoot>
      {config.isDev && <GlobalDevStyle />}
      <App queryClient={queryClient} />
    </RecoilRoot>
  </React.StrictMode>,
);
